import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface UserGuardProps {
  children: React.ReactNode;
}

export function UserGuard({ children }: UserGuardProps) {
  const navigate = useNavigate();
  const { authUser, isAdmin, isSupportUser, needsOnboarding, subscriptionEnded, loading } = useAuth();

  useEffect(() => {
    if (!loading) {
      if (!authUser) {
        navigate('/login', { replace: true });
      } else if (isAdmin) {
        navigate('/admin/dashboard', { replace: true });
      } else if (isSupportUser) {
        navigate('/support', { replace: true });
      } else if (subscriptionEnded) {
        navigate('/abonnement-gestopt', { replace: true });
      } else if (needsOnboarding) {
        navigate('/onboarding', { replace: true });
      }
    }
  }, [authUser, isAdmin, isSupportUser, needsOnboarding, subscriptionEnded, loading, navigate]);

  if (loading || !authUser || isAdmin || isSupportUser || needsOnboarding || subscriptionEnded) {
    return null;
  }

  return <>{children}</>;
}
